module.exports = __webpack_public_path__ + "static/media/29_B.5e1db374.png";